// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"3ffb3f2a","832":"ab3d9d10"}[chunkId] + ".chunk.js";
};